<template>
  <div v-if="prompt.type === 'file'">
    <payload-file
      :minioHost="minioHost"
      :index="index"
      :prompt="prompt"
      :items="voicePaths"
      :isMainPlaying="isMainPlaying"
      @isSubPlaying="isSubPlaying"
      @deletePrompt="deletePrompt"
    />
  </div>
  <div v-else-if="prompt.type === 'tts'">
    <payload-tts
      :minioHost="minioHost"
      :index="index"
      :prompt="prompt"
      :items="voicePaths"
      :ttsProperty="ttsProperty"
      :isMainPlaying="isMainPlaying"
      @isSubPlaying="isSubPlaying"
      @deletePrompt="deletePrompt"
      :drawFlowItems="drawFlowItems"
      :apiForIntellisense="apiForIntellisense"
    />
    <!--use for Intellisense มีเพิ่ม :drawFlowItems="drawFlowItems" เพื่อใช้ใน Intellisense -->
  </div>
  <div v-else-if="prompt.type === 'tts_cache'">
    <payload-tts-cache
      :minioHost="minioHost"
      :index="index"
      :prompt="prompt"
      :items="voicePaths"
      :ttsProperty="ttsProperty"
      :isMainPlaying="isMainPlaying"
      @isSubPlaying="isSubPlaying"
      @deletePrompt="deletePrompt"
      :drawFlowItems="drawFlowItems"
      :apiForIntellisense="apiForIntellisense"
    />
    <!--use for Intellisense มีเพิ่ม :drawFlowItems="drawFlowItems" เพื่อใช้ใน Intellisense -->
  </div>
  <div v-else-if="prompt.type === 'parameter'">
    <payload-parameter
      :index="index"
      :prompt="prompt"
      :items="parameters"
      :categories="categories"
      @deletePrompt="deletePrompt"
      :drawFlowItems="drawFlowItems"
      :apiForIntellisense="apiForIntellisense"
    />

    <!--use for Intellisense มีเพิ่ม :drawFlowItems="drawFlowItems" เพื่อใช้ใน Intellisense -->
  </div>
  <div v-else-if="prompt.type === 'url'">
    <payload-url :index="index" :prompt="prompt" @deletePrompt="deletePrompt" />
  </div>
  <div v-else-if="prompt.type === 'pause'">
    <payload-pause
      :index="index"
      :prompt="prompt"
      @deletePrompt="deletePrompt"
    />
  </div>
</template>

<script>
import PayloadFile from './file'
import PayloadParameter from './parameter'
import PayloadTts from './tts'
import PayloadTtsCache from './tts_cache'
import PayloadUrl from './url'
import PayloadPause from './pause'

export default {
  components: {
    PayloadFile,
    PayloadParameter,
    PayloadTts,
    PayloadTtsCache,
    PayloadUrl,
    PayloadPause
  },
  props: {
    minioHost: String,
    index: Number,
    prompt: Object,
    voicePaths: Array,
    parameters: Array,
    categories: Array,
    ttsProperty: Object,
    isMainPlaying: Boolean,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  methods: {
    isSubPlaying() {
      this.$emit('isSubPlaying', null)
    },
    deletePrompt(index) {
      this.$emit('deletePrompt', index)
    }
  }
}
</script>
